import React, { useEffect, useState } from 'react';
import { Platform } from 'react-native';
import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons';
import { useNavigate } from 'react-router-dom';

const DISMISS_KEY = 'siteAnnouncementDismissed:boston-launch';

const SiteAnnouncementBanner = () => {
    const navigate = useNavigate();
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        try {
            const dismissed = window.localStorage.getItem(DISMISS_KEY) === '1';
            if (dismissed) {
                setIsVisible(false);
            }
        } catch {
            // Ignore storage read issues and keep banner visible.
        }
    }, []);

    const handleDismiss = () => {
        setIsVisible(false);
        try {
            window.localStorage.setItem(DISMISS_KEY, '1');
        } catch {
            // Ignore storage write issues.
        }
    };

    if (Platform.OS !== 'web' || !isVisible) {
        return null;
    }

    return (
        <div style={styles.wrapper}>
            <div style={styles.inner}>
                <div style={styles.badge}>
                    <MaterialCommunityIcons name="bullhorn-outline" size={14} color="#1D4ED8" />
                    <span style={styles.badgeText}>Announcement</span>
                </div>

                <div style={styles.message}>
                    SnapCamp is going live in Massachusetts!
                </div>

                <div style={styles.actions}>
                    <button type="button" style={styles.cta} onClick={() => navigate('/announcements')}>
                        <span style={styles.ctaText}>Learn more</span>
                        <MaterialCommunityIcons name="arrow-right" size={15} color="#1D4ED8" />
                    </button>
                    <button type="button" style={styles.dismissButton} onClick={handleDismiss} aria-label="Dismiss announcement">
                        <MaterialCommunityIcons name="close" size={16} color="#64748B" />
                    </button>
                </div>
            </div>
        </div>
    );
};

const styles = {
    wrapper: {
        position: 'fixed' as const,
        top: '122px',
        left: '50%',
        transform: 'translateX(-50%)',
        width: 'min(760px, calc(100vw - 32px))',
        zIndex: 120,
        pointerEvents: 'auto' as const,
    },
    inner: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '16px',
        flexWrap: 'wrap' as const,
        padding: '12px 16px',
        borderRadius: '18px',
        backgroundColor: 'rgba(239,246,255,0.96)',
        border: '1px solid #BFDBFE',
        boxShadow: '0 12px 28px rgba(15, 23, 42, 0.14)',
        backdropFilter: 'blur(10px)',
    },
    badge: {
        display: 'flex',
        flexDirection: 'row' as const,
        alignItems: 'center',
        gap: '6px',
        padding: '6px 10px',
        borderRadius: '999px',
        backgroundColor: '#FFFFFF',
        border: '1px solid #BFDBFE',
        whiteSpace: 'nowrap' as const,
    },
    badgeText: {
        fontSize: '12px',
        fontWeight: 700,
        color: '#1D4ED8',
        textTransform: 'uppercase' as const,
        letterSpacing: '0.3px',
    },
    message: {
        flex: 1,
        minWidth: '240px',
        fontSize: '15px',
        lineHeight: '22px',
        fontWeight: 600,
        color: '#0F172A',
    },
    cta: {
        display: 'flex',
        flexDirection: 'row' as const,
        alignItems: 'center',
        gap: '6px',
        border: 'none',
        background: 'transparent',
        padding: 0,
        cursor: 'pointer',
        whiteSpace: 'nowrap' as const,
    },
    ctaText: {
        fontSize: '14px',
        fontWeight: 700,
        color: '#1D4ED8',
    },
    actions: {
        display: 'flex',
        flexDirection: 'row' as const,
        alignItems: 'center',
        gap: '8px',
    },
    dismissButton: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '30px',
        height: '30px',
        borderRadius: '999px',
        border: '1px solid #D1D5DB',
        backgroundColor: '#FFFFFF',
        cursor: 'pointer',
        padding: 0,
    },
};

export default SiteAnnouncementBanner;
